import * as React from 'react';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';
import { object as PropObject } from 'prop-types';
import { Panel, ListGroup, ListGroupItem } from 'react-bootstrap';

import '../gs-core/common/util/array.prototype';
import { Organization, toSentence, UserModel } from '../gs-core/common';

import './Sidebar.css';
import { ActionTypes, EDocsPermissions, PermissionEvaluator } from '../common/models';
import { ServiceRegistry } from '../services';

interface SidebarProps { show: boolean; }

interface SidebarState { units: Organization[]; myUnits: Organization[]; adminsAccess: boolean; }

export class Sidebar extends React.Component<SidebarProps, SidebarState> {
  static contextTypes = { services: PropObject };

  constructor(props: SidebarProps) {
    super(props);
    this.state = {
      units: [],
      myUnits: [],
      adminsAccess: false
    };
  }

  async componentDidMount() {
    const { currentUserService, owningUnitService, errorLogger } = this.context.services as ServiceRegistry;

    try {
      const currentUser = await currentUserService.find();

      if (!currentUser || !currentUser.isUnder) {
        throw new Error('Unable to find current user');
      }

      const permissions = await currentUserService.findPermissions();
      const adminsAccess = permissions.some(permission => permission.code === EDocsPermissions.ADMIN_ACCESS);

      const permissionEvaluator = PermissionEvaluator.forUser(currentUser).withPermissions(permissions);

      const myUnits = permissionEvaluator.findOwningUnits();

      const editScopeGroups = permissionEvaluator.findScopeGroups(ActionTypes.EDIT);
      const otherUnits = await owningUnitService.findOwningUnitsUnder(editScopeGroups);

      const units = myUnits.concat(otherUnits)
        .unique()
        .sort(UserModel.sort);

      this.setState({ units, myUnits, adminsAccess });
    } catch (err) {
      await errorLogger.log(err);
    }
  }

  programAndCollegeDesc(program: Organization): string {
    const parts: string[] = [program.code || program.name];
    const colleges = program && program.findRoles &&
      program.findRoles('SUBUNIT').map(userRole => userRole.group.code || userRole.group.name);

    if (colleges) {
      parts.push(...colleges);
    }

    return toSentence(parts);
  }

  render() {
    const { units, myUnits, adminsAccess } = this.state;

    return (
      <Panel className={`Sidebar ${!this.props.show ? 'hidden' : ''}`}>
        <ListGroup>
          <LinkContainer to="/" activeClassName="selected" exact={true}>
            <ListGroupItem>
              <i className="fa fa-inbox fa-fw fa-lg text-muted"/><span>My uploads</span>
            </ListGroupItem>
          </LinkContainer>
        </ListGroup>

        <ListGroup className="bordered">
          <ListGroupItem className="header">Owning Units</ListGroupItem>
          {units.map(unit =>
            <React.Fragment key={unit.id}>
              <LinkContainer to={`/unit/${unit.id}`} activeClassName="selected">
                <ListGroupItem>
                  <i className="fa fa-tag fa-fw fa-lg text-muted"/>
                  <span>{unit.displayName || unit.name}</span>
                </ListGroupItem>
              </LinkContainer>
              { unit.isOfType && unit.isOfType('MajorProgram') &&
                <LinkContainer to={`/program/${unit.id}`} activeClassName="selected">
                  <ListGroupItem className="SidebarSubItem">
                    <i className="fa fa-tags fa-fw fa-lg text-muted"/>
                    <span>Shared Program Docs</span>
                  </ListGroupItem>
                </LinkContainer>
              }
              { myUnits.some(myUnit => myUnit.id === unit.id) &&
                <LinkContainer to={`/unit/${unit.id}/titles`} activeClassName="selected">
                  <ListGroupItem className="SidebarSubItem">
                    <i className="fa fa-font fa-fw fa-lg text-muted"/><span>Titles</span>
                  </ListGroupItem>
                </LinkContainer>
              }
            </React.Fragment>
          )}
        </ListGroup>

        {adminsAccess &&
          <ListGroup>
            <LinkContainer to="/job" activeClassName="selected" key="jobs">
              <ListGroupItem>
                <i className="fa fa-hourglass-1 fa-fw fa-lg text-muted"/><span>Jobs</span>
              </ListGroupItem>
            </LinkContainer>
          </ListGroup>
        }
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Sidebar/Sidebar.tsx